// extracted by mini-css-extract-plugin
export var cardContainer = "stacks-card-carousel-module--cardContainer--43166";
export var moduleContainer = "stacks-card-carousel-module--moduleContainer--e114a";